(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hayz-journal-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('hayz-journal-carousel')){
    customElements.define('hayz-journal-carousel',class extends HTMLElement{
      connectedCallback(){
        this.controller?.abort();
        this.controller=new AbortController();
        const track=this.querySelector('.hayz-journal__track');
        if(!track)return;
        this.addEventListener('click',event=>{
          const button=event.target.closest('[data-journal-step]');
          if(!button)return;
          const rtl=getComputedStyle(track).direction==='rtl';
          const width=track.querySelector('article')?.getBoundingClientRect().width||track.clientWidth;
          const gap=parseFloat(getComputedStyle(track).columnGap)||0;
          track.scrollBy({left:(width+gap)*Number(button.dataset.journalStep)*(rtl?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        },{signal:this.controller.signal});
      }
      disconnectedCallback(){this.controller?.abort()}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
